import React, {useContext, useEffect, useState} from 'react';
import '../styles/CalculationsContainer.css';
import $ from 'jquery';
import {
    calculationDeleteAPI,
    calculationGetAPI,
    calculationGetByIdAPI,
    calculationGetCountsAPI,
    CalcCounts,
    calculationUpdateStatusAPI, calculationUpdateTbDataAPI
} from "../http/calculationAPI";
import {Context} from "../index";
import {WsTriggers} from "../WebsocketTriggers";
import {formatDateString} from "../utils/utilsFunctions";
import CalculationTable, {
    fillUpTable,
    gatherTableData,
    setTableState,
    CalcConfig,
    DEFAULT_CALC_CONFIG,
    normalizeCalcConfig,
    configOfCalcTable
} from "./CalculationTable";
import {pdfPutAPI, pdfCalcDownloadAPI} from "../http/pdfAPI";
import DeliveryNoteSection from "./DeliveryNoteSection";
import {payeesGetApi} from "../http/payeeAPI";
import {REACT_APP_API_URL} from "../config";
import { getCookie, setCookie } from '../utils/cookies';

const unwrapIco = require('../assets/icons/selectedComp/unwrapIco.png')


type OptionsType = 'calcAll' | 'calcPaid' | 'calcNotPaid' | 'calcPending';
export type CalculationDataType = {
    id: number,
    status: boolean | null,
    invoice: string | null,
    payeeId: number | null,
    payee?: { id: number, name: string, calcConfig?: any } | null,
    payeeSnapshot?: { calcConfig?: any } | null,
    // The CalcTable this calculation was pinned to at creation (see backend
    // CalculationController.post) — takes priority over `payeeSnapshot`/`payee`
    // below, which only cover calculations that predate CalcTable.
    calcTable?: { id: number, name: string, config: any, hiddenColumns?: string[] | null, isArchived?: boolean } | null,
    calculation: {
        tableData: {
            [key: number]: {
                a: string,
                b: string,
                c: string,
                d: string,
                e: string,
                f: string,
                g: string,
                h: string,
                i: string,
                j: string,
                k: string,
                l: string,
            }
        },
        // Snapshot of the footer fields as displayed at save time — keyed by
        // whatever CalcFooterField.key each was (admin-defined; the fixed
        // expensesTax/incomeTax/profit names are just the legacy default set).
        tableResult: { [key: string]: string },
    },
    createdAt: string,
    updatedAt: string,
    closedAt: string | null,
    companyId: number,
    pdfFile: string | null,
    company: {
        id: number,
        name: string
    },
    createdBy: { id: number, username: string },
    closedBy: { id: number, username: string }
}

const statusToJSX: { [key: string]: JSX.Element } = {
    'null': <span className="" style={{ color: 'var(--main-color)' }}>В ожидании</span>,
    'false': <span className="" style={{ color: 'var(--warning-color)' }}>Не оплачен</span>,
    'true': <span className="" style={{ color: 'var(--success-color)' }}>Оплачен</span>,
}



const CalculationsContainer = (props: {
    setIsActive: React.Dispatch<React.SetStateAction<boolean>>
    setHeaderName: React.Dispatch<React.SetStateAction<string>>
    setBodyDivElement: React.Dispatch<React.SetStateAction<JSX.Element>>
}) => {
    const {user, ws} = useContext(Context);

    useEffect(() => {
        const message: string | null = ws.getMsg;
        if (message !== null) {
            const compId = `${window.location.pathname}`.split('/').pop();
            if (message === WsTriggers.CALC + `+${compId}`) {
                requestCalculation();
                requestCalcCounts();

                ws.setMessage(null);
            }

        }
    }, [ws.getMsg]);


    const [selectedOption, setSelectedOption] = useState<OptionsType>('calcPending');
    const [companyId, setCompanyId] = useState(window.location.pathname.split('/').pop());

    const [payees, setPayees] = useState<Array<{ id: number, name: string, calcConfig: CalcConfig }>>([]);
    const [selectedPayee, setSelectedPayee] = useState<string>('all');

    const [calcData, setCalcData] = useState<Array<CalculationDataType>>([]);
    const [calcDataById, setCalcDataById] = useState<CalculationDataType | null>(null);
    const [calcCounts, setCalcCounts] = useState<CalcCounts | null>(null);

    const [perms, setPerms] = useState<Set<string>>(new Set());

    const [isTableEditable, setIsTableEditable] = useState<boolean>(false);
    const [plainPdfBusy, setPlainPdfBusy] = useState<boolean>(false);

    useEffect(() => {
        setPerms(user.getPermissions.data_);
    }, [user.getPermissions]);

    useEffect(() => {
        payeesGetApi().then((res) => {
            if (Array.isArray(res?.data)) {
                setPayees(res.data.map((p: any) => ({
                    id: p.id,
                    name: p.name,
                    calcConfig: normalizeCalcConfig(configOfCalcTable(p.currentCalcTable) ?? p.calcConfig),
                })));
            }
        });
    }, []);

    useEffect(() => {
        requestCalculation();
    }, [selectedOption, selectedPayee]);

    // Counts don't depend on which tab is selected -- they're what tells you
    // how many invoices each tab hides -- so they're only re-fetched on
    // company/payee changes, not on every tab switch.
    useEffect(() => {
        requestCalcCounts();
    }, [selectedPayee]);

    const requestCalcCounts = () => {
        if (companyId) {
            calculationGetCountsAPI(companyId, selectedPayee)
                .then((response) => {
                    if (response.data) {
                        setCalcCounts(response.data);
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    const requestCalculation = () => {
        if (companyId) {
            calculationGetAPI(companyId, selectedOption, selectedPayee)
                .then((response) => {
                    if (response.data) {
                        setCalcData(response.data);                        
                    }
                    if (calcDataById && $('#popup').length > 0) {
                        requestCalculationById(calcDataById.id);
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    const requestCalculationById = (id: string | number) => {
        if (companyId) {
            calculationGetByIdAPI(id)
                .then((response) => {
                    if (response.data) {
                        setCalcDataById(response.data);
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    useEffect(() => {
        if (calcDataById) {
            props.setIsActive(true)
            props.setHeaderName('Расчёт')
            props.setBodyDivElement(popupCalcTable)
        }
        if ($('.calcPopup__save-btn').css('display') == 'block') {
            getTableToPrevCondition();
        }
    }, [calcDataById]);


    const changeCalcStatus = (status: 'paid' | 'notPaid') => {
        if (calcDataById) {
            calculationUpdateStatusAPI(calcDataById.id, status, user.getUser.id)
                .then((response) => {
                    if (response.status === 200) {
                        requestCalculationById(calcDataById.id);

                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    const getTableToPrevCondition = () => {
        if (calcDataById) {
            fillUpTable({ Key: 'Popup', tableData: calcDataById.calculation.tableData })
            setTableState({ Key: 'Popup', isEditable: false });
            $('.calcPopup__save-btn').css({ display: 'none' });
            $('.calcPopup__cancel-btn').css({ display: 'none' });
        }
    };

    const editTableDataHandler = () => {
        $('.calcPopup__save-btn').css({ display: 'block' });
        $('.calcPopup__cancel-btn').css({ display: 'block' });

        $(document).off('click', '.calcPopup__save-btn');
        $(document).off('click', '.calcPopup__cancel-btn');
        $(document).on('click', '.calcPopup__save-btn', function () {
            const updatedTbData = gatherTableData({ Key: 'Popup' });
            if (calcDataById) {
                calculationUpdateTbDataAPI(calcDataById.id, updatedTbData)
                    .then((response) => {
                        if (response.status === 200) {
                            requestCalculationById(calcDataById.id);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        })
        $(document).on('click', '.calcPopup__cancel-btn', function () {
            getTableToPrevCondition();
        })



    }

    const createPdfBtn = (
            <button className='nav__button btn-ghost calcPopup__toolsBtn calcPopup__toolsBtn-pdf'
                    onClick={() => {
                        if (calcDataById) {
                            $('.calcPopup__toolsBtn-pdf').css({ 'display': 'none' });
                            $('.pdfUpdateLoader').css({ 'display': 'block' });
                            $('.calcPopup__toolsBtn-delete').css({ 'display': 'none' });
                            $('.calcPopup__toolsBtn-delete-unusable').css({ 'display': 'block' });

                            pdfPutAPI(calcDataById.id)
                                .then((response) => {
                                    console.log(response)
                                    $('.pdfUpdateLoader').css({ 'display': 'none' });
                                    $('.calcPopup__toolsBtn-pdf').css({ 'display': 'block' });
                                    $('.calcPopup__toolsBtn-delete').css({ 'display': 'block' });
                                    $('.calcPopup__toolsBtn-delete-unusable').css({ 'display': 'none' });
                                })
                                .catch((err) => {
                                    console.log(err)
                                })
                        }
                    }}
            >Сформировать pdf</button>
    )
    const reCreatePdfBtn = (
        <button className='nav__button btn-ghost calcPopup__toolsBtn calcPopup__toolsBtn-pdf-recreate'
                onClick={() => {
                    if (calcDataById) {
                        $('.calcPopup__toolsBtn-pdf-recreate').css({ 'display': 'none' });
                        $('.pdfUpdateLoader').css({ 'display': 'block' });
                        $('.calcPopup__toolsBtn-delete').css({ 'display': 'none' });
                        $('.calcPopup__toolsBtn-delete-unusable').css({ 'display': 'block' });


                        pdfPutAPI(calcDataById.id)
                            .then((response) => {
                                console.log(response)
                                $('.pdfUpdateLoader').css({ 'display': 'none' });
                                $('.calcPopup__toolsBtn-pdf-recreate').css({ 'display': 'block' });
                                $('.calcPopup__toolsBtn-delete').css({ 'display': 'block' });
                                $('.calcPopup__toolsBtn-delete-unusable').css({ 'display': 'none' });

                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                }}
        >Пересоздать pdf</button>
    )

    // Скачать счёт без печати/подписи, ничего не сохраняя на сервере.
    const downloadPlainPdf = async () => {
        if (!calcDataById || plainPdfBusy) return;
        setPlainPdfBusy(true);
        const res: any = await pdfCalcDownloadAPI(calcDataById.id, { stamp: false, sign: false });
        setPlainPdfBusy(false);

        const blob: Blob | undefined = res?.data instanceof Blob ? res.data : undefined;
        if (res?.status !== 200 || !blob) {
            let msg = 'Не удалось сформировать PDF';
            try {
                const errBlob: Blob | undefined = res?.response?.data instanceof Blob ? res.response.data : blob;
                if (errBlob) msg = (await errBlob.text()).replace(/^"|"$/g, '') || msg;
            } catch {
                /* общее сообщение */
            }
            window.alert(msg);
            return;
        }

        let name = 'Рахунок-фактура (без печатки).pdf';
        const cd: string | undefined = res?.headers?.['content-disposition'];
        const m = cd ? /filename\*=UTF-8''([^;]+)/i.exec(cd) : null;
        if (m) {
            try { name = decodeURIComponent(m[1]); } catch { /* оставляем дефолт */ }
        }

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
    };

    const downloadPlainPdfBtn = (
        <button className='nav__button btn-ghost calcPopup__toolsBtn'
                disabled={plainPdfBusy}
                onClick={downloadPlainPdf}>
            {plainPdfBusy ? 'Формируется…' : 'Скачать без печати'}
        </button>
    )

    // Config (rates + column schema) for the popup table: prefer the CalcTable
    // this calc was pinned to at creation (immutable once used — see CalcTable
    // on the backend), then the legacy snapshot frozen at invoice issue, then
    // the calc's live payee, then the payee row by id, then the defaults.
    const popupCalcConfig: CalcConfig = (() => {
        const pinned = configOfCalcTable(calcDataById?.calcTable);
        if (pinned) return normalizeCalcConfig(pinned);
        const frozen = calcDataById?.payeeSnapshot?.calcConfig;
        if (frozen) return normalizeCalcConfig(frozen);
        const fromCalcPayee = calcDataById?.payee?.calcConfig;
        if (fromCalcPayee) return normalizeCalcConfig(fromCalcPayee);
        const pid = calcDataById?.payeeId ?? null;
        const hit = pid != null ? payees.find((p) => p.id === pid) : undefined;
        return hit ? hit.calcConfig : DEFAULT_CALC_CONFIG;
    })();

    // Action buttons for the opened calc. Used to live in a slide-out side
    // panel that had to be revealed by a click; now a plain toolbar pinned to
    // the top of the popup body, visible the moment it opens.
    const calcToolbar = (
        (perms.has('calculation.update') || perms.has('calculation.delete')) && calcDataById ?
            <div className='calcPopup__toolbar'>
                {
                    perms.has('calculation.update') ?
                        <>
                            <div className='calcPopup__toolbar-group'>
                                {
                                    calcDataById.status === true ? <button className='calcPopup__toolsBtn-unusable'>Оплачено</button>
                                    : <button className='nav__button btn-primary calcPopup__toolsBtn calcPopup__toolsBtn-paid' onClick={() => {changeCalcStatus('paid')}}>Оплачено</button>
                                }
                                {
                                    calcDataById.status === false ? <button className='calcPopup__toolsBtn-unusable'>Не оплачено</button>
                                    : <button className='nav__button btn-danger calcPopup__toolsBtn calcPopup__toolsBtn-notPaid' onClick={() => { changeCalcStatus('notPaid')}}>Не оплачено</button>
                                }
                            </div>
                            <div className='calcPopup__toolbar-group'>
                                { calcDataById.pdfFile ? reCreatePdfBtn : createPdfBtn }
                                { downloadPlainPdfBtn }
                            </div>
                            <div className='calcPopup__toolbar-group'>
                                <button className='nav__button btn-ghost calcPopup__toolsBtn calcPopup__toolsBtn-edit'
                                        onClick={() => {
                                            setTableState({Key: 'Popup', isEditable: true,});
                                            editTableDataHandler();
                                        }}
                                >
                                    Редактировать
                                </button>
                            </div>
                        </>
                        :
                        null
                }
                {
                    perms.has('calculation.delete') ?
                        <div className='calcPopup__toolbar-group calcPopup__toolbar-group--end'>
                            <button className='nav__button btn-danger calcPopup__toolsBtn calcPopup__toolsBtn-delete'
                                    onClick={() => {
                                        if (calcDataById) {
                                            calculationDeleteAPI(calcDataById.id)
                                                .then((response) => {
                                                    console.log(response)
                                                    if (response.status === 200) {
                                                        props.setIsActive(false);
                                                    }
                                                })
                                                .catch((err) => {
                                                    console.log(err)
                                                })
                                        }
                                    }}
                            >Удалить</button>
                            <button className='calcPopup__toolsBtn-unusable calcPopup__toolsBtn-delete-unusable'>Удалить</button>
                        </div>
                        :
                        null
                }
            </div>
            : null
    );

    const popupCalcTable = (
        <div className='selectedComp__calc-popup-body-wrapper'>
            { calcToolbar }
            {
                calcDataById ?
                    <table className='calcPopup__table'>
                        <tbody className='calcPopup__tbody'>
                        <tr className='calcPopup__tr'>
                            <td className='calcPopup__td calcPopup__td-static'>Создал:</td>
                            <td className='calcPopup__td calcPopup__td-dynamic'>{calcDataById.createdBy ? calcDataById.createdBy.username : '-'}</td>
                            <td className='calcPopup__td calcPopup__td-static'>Дата:</td>
                            <td className='calcPopup__td calcPopup__td-dynamic'>{formatDateString(calcDataById.createdAt)}</td>
                            <td className='calcPopup__td calcPopup__td-static'>Счёт-фактура:</td>
                            <td className='calcPopup__td calcPopup__td-dynamic'>{calcDataById.invoice ? calcDataById.invoice : '-'}</td>
                            <td className='calcPopup__td calcPopup__td-static'>Рахунок-фактура:</td>
                            <td className='calcPopup__td calcPopup__td-dynamic'>{calcDataById.pdfFile ?
                                <a href={`${REACT_APP_API_URL}media/${calcDataById.pdfFile}`}
                                        target='_blank'
                                        onClick={() => {
                                            const cookieJwt = localStorage.getItem('token');
                                            if (cookieJwt) {
                                                setCookie('cookieJwt', cookieJwt, 7);
                                            }
                                        }}      
                                >{calcDataById.pdfFile}</a> : '-'}</td>
                        </tr>
                        <tr className='calcPopup__tr'>
                            <td className='calcPopup__td calcPopup__td-static'>Закрыл:</td>
                            <td className='calcPopup__td calcPopup__td-dynamic'>{calcDataById.closedBy ? calcDataById.closedBy.username : '-'}</td>
                                <td className='calcPopup__td calcPopup__td-static'>Дата:</td>
                                <td className='calcPopup__td calcPopup__td-dynamic'>{calcDataById.closedAt !== null ? formatDateString(calcDataById.closedAt) : '-'}</td>
                                <td className='calcPopup__td calcPopup__td-static'>Статус:</td>
                                <td className='calcPopup__td calcPopup__td-dynamic'>{statusToJSX[`${calcDataById.status}`]}</td>
                            </tr>
                        </tbody>
                    </table>
                    :
                    null
            }
            <div className='calcPopup__calculation-container'>
                <CalculationTable
                    isEditable={isTableEditable}
                    Key={'Popup'}
                    tableData={ calcDataById ? calcDataById.calculation.tableData : undefined }
                    calcConfig={popupCalcConfig}
                />
            </div>
            <div className='calcPopup__result-container'>
                <div className='calcPopup__result-btn-container'>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <button className='nav__button btn-primary calcPopup__save-btn calcPopup__toolsBtn'>Сохранить</button>
                        <button className='nav__button btn-ghost calcPopup__cancel-btn calcPopup__toolsBtn'>Отмена</button>
                    </div>
                </div>
                <div id='Popup-footer' style={{display: "flex", flexDirection: 'column'}}></div>
            </div>
            {
                calcDataById ?
                    <DeliveryNoteSection key={calcDataById.id}
                                         calcId={calcDataById.id}
                                         invoice={calcDataById.invoice}
                                         canEdit={perms.has('calculation.update')}/>
                    : null
            }
        </div>
    )


    return (
        <div className="selectedComp__calcs-container contentWindow">
            <div className="selectedComp__data-header contentWindow__header">
                <span className="contentWindow__name">Расчёты</span>
            </div>
            <nav className="selectedComp__data-nav contentWindow__nav tab-group">
                <button className={`tab ${selectedOption === 'calcAll' ? 'is-active' : ''}`} onClick={() => {
                    setSelectedOption('calcAll')
                }}>Все{calcCounts && <span className="tab__count">{calcCounts.calcAll}</span>}
                </button>
                <button className={`tab ${selectedOption === 'calcPaid' ? 'is-active' : ''}`} onClick={() => {
                    setSelectedOption('calcPaid')
                }}>Оплачено{calcCounts && <span className="tab__count">{calcCounts.calcPaid}</span>}
                </button>
                <button className={`tab ${selectedOption === 'calcNotPaid' ? 'is-active' : ''}`} onClick={() => {
                    setSelectedOption('calcNotPaid')
                }}>Не оплачено{calcCounts && <span className="tab__count">{calcCounts.calcNotPaid}</span>}
                </button>
                <button className={`tab ${selectedOption === 'calcPending' ? 'is-active' : ''}`} onClick={() => {
                    setSelectedOption('calcPending')
                }}>В ожидании{calcCounts && <span className="tab__count">{calcCounts.calcPending}</span>}
                </button>
                {
                    payees.length > 0 &&
                    <select className='select selectedComp__calc-payee-select'
                            value={selectedPayee}
                            title='Получатель платежа'
                            onChange={(e) => setSelectedPayee(e.target.value)}>
                        <option value='all'>Все получатели</option>
                        {payees.map((p) => <option key={p.id} value={`${p.id}`}>{p.name}</option>)}
                        <option value='none'>Без получателя</option>
                    </select>
                }
            </nav>
            <div className="selectedComp__calc-data-body contentWindow__body">
                {
                    calcData.length === 0 ?
                        <div className="selectedComp__calculation-container-wrapper"
                             style={{display: 'flex', justifyContent: 'center', color: 'var(--color-text-tertiary)', padding: 'var(--space-4) 0'}}
                        >Ничего нет</div>
                        :
                        calcData.map((cd) =>
                            <div key={`calc${cd.id}`} className="selectedComp__calculation-container-wrapper">
                                <div className="selectedComp__calculation-container">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td className='selectedComp__calc-td-static'>Создал:</td>
                                            <td className='selectedComp__calc-td-dynamic'>{cd.createdBy ? cd.createdBy.username : '-'}</td>
                                            <td className='selectedComp__calc-td-static'>Дата:</td>
                                            <td className='selectedComp__calc-td-dynamic'>{formatDateString(cd.createdAt)}</td>
                                            <td className='selectedComp__calc-td-static'>Счёт-фактура: </td>
                                            <td className='selectedComp__calc-td-dynamic'>{ cd.invoice ? cd.invoice : '-' }</td>
                                            <td className='selectedComp__calc-td-btn-container'>
                                                <button className='selectedComp__calc-btn-openPopup'
                                                    onClick={() => {
                                                        requestCalculationById(cd.id);
                                                    }}
                                                >
                                                    <img src={unwrapIco} className='selectedComp__calc-btn-openPopup-unwrapIco' alt="-"/>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='selectedComp__calc-td-static'>Закрыл:</td>
                                            <td className='selectedComp__calc-td-dynamic'>{cd.closedBy ? cd.closedBy.username : '-'}</td>
                                            <td className='selectedComp__calc-td-static'>Дата:</td>
                                            <td className='selectedComp__calc-td-dynamic'>{cd.closedAt !== null ? formatDateString(cd.closedAt) : '-'}</td>
                                            <td className='selectedComp__calc-td-static'>Статус:</td>
                                            <td className='selectedComp__calc-td-dynamic'>{statusToJSX[`${cd.status}`]}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td className='selectedComp__calc-td-static'>Получатель:</td>
                                            <td className='selectedComp__calc-td-dynamic' colSpan={5}>{cd.payee ? cd.payee.name : '-'}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )

                }
            </div>
        </div>
    );
};

export default CalculationsContainer;
